import { ComponentProps, ReactNode, Suspense } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";
import { ChunkLoadErrorBoundary, lazyChunk } from "@shared/ChunkLoadErrorBoundary";
import { LoadingBox } from "@shared/Loading";
import { MinimalTableBody, MinimalTableCell, MinimalTableRow } from "@shared/table/MinimalTableComponents";

import type SortablePolicyCommandsBodyComponent from "./SortablePolicyCommandsBody";

const LazySortablePolicyCommandsBody = lazyChunk(() => import("./SortablePolicyCommandsBody"));

const MessageBody = ({ children }: { children: ReactNode }) => (
    <MinimalTableBody>
        <MinimalTableRow>
            <MinimalTableCell colSpan={4}>{children}</MinimalTableCell>
        </MinimalTableRow>
    </MinimalTableBody>
);

const LoadFailedBody = () => {
    const { t } = useTranslation("common");

    return (
        <MessageBody>
            <Typography color="error">{t("error.failedToLoadFeature")}</Typography>
        </MessageBody>
    );
};

export const SortablePolicyCommandsBody = (props: ComponentProps<typeof SortablePolicyCommandsBodyComponent>) => (
    <ChunkLoadErrorBoundary fallback={<LoadFailedBody />}>
        <Suspense
            fallback={
                <MessageBody>
                    <LoadingBox />
                </MessageBody>
            }
        >
            <LazySortablePolicyCommandsBody {...props} />
        </Suspense>
    </ChunkLoadErrorBoundary>
);
